import React, { memo } from 'react';
import Input from '../../../../../commons/components/primitives/Input';
import { Dac7FormInputName } from '../types/Dac7FormInputName';

interface Props {
  name: Dac7FormInputName;
  label?: string;
  placeholder?: string;
  pattern?: string | RegExp;
  required?: boolean;
  type?: 'text' | 'number' | 'hidden';
  value: string;
  disabled?: boolean;
}

const Dac7Input = ({
  name,
  label = '',
  placeholder,
  pattern,
  required,
  type = 'text',
  value,
  disabled = false,
}: Props) => (
  <Input
    name={name}
    label={label}
    placeholder={placeholder}
    pattern={pattern}
    required={required}
    type={type}
    value={value}
    disabled={disabled}
  />
);

export default memo(Dac7Input);
